import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import {
  getEquipmentNameList,
  getApplicableSeviceTypewithIdList,
} from "../Actions/helpersAPI";
import {
  getZoneList,
  getUnitList,
  getVendorList,
} from "../Actions/VendorManagementAPI";
import axios from "axios";
import { getPortAndCountry } from "../Actions/ServiceProviderAPI";
import API from "../helpers/api";
import { toast } from "react-toastify";
import $ from "jquery";
import swal from "sweetalert";
import Autocomplete from "react-autocomplete";
import { getServiceTypeList } from "../Actions/CommonAPI";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

let searchData = {
  Equipment: "",
  Zone: "",
  country: "",
  port: "",
  VendorName: "",
  PageNumber: 1,
  PageSize: 20,
};
class EditVendor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        VendorId: 0,
        EquipmentId: "",
        vendorName: "",
        ZoneId: 0,
        ServiceType: "",
        UnitId: 0,
        Quantity: "",
        Price: "",
        country: "",
        port: "",
        isDeleted: false,
        modifiedBy: currentuser.email,
      },
      inValidFields: [],
      selectedServiceTypes: [],
    };
    this.UpdateVendor = this.UpdateVendor.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { VendorEquipmentDetails, dispatch } = nextProps;
    if (VendorEquipmentDetails && VendorEquipmentDetails !== "") {
      prevState.searchData.VendorId = VendorEquipmentDetails.vendorId;
      prevState.searchData.vendorName = VendorEquipmentDetails?.vendorName
        ? VendorEquipmentDetails?.vendorName
        : "";
      prevState.searchData.EquipmentId = VendorEquipmentDetails.equipmentName;
      prevState.searchData.Price = VendorEquipmentDetails.price;
      prevState.searchData.ZoneId = VendorEquipmentDetails.zoneId;
      prevState.searchData.UnitId = VendorEquipmentDetails.unitId;
      prevState.searchData.Quantity = VendorEquipmentDetails.quantity;
      prevState.searchData.ServiceType = VendorEquipmentDetails.serviceTypeId;
      prevState.searchData.country = VendorEquipmentDetails.countryName;
      prevState.searchData.port = VendorEquipmentDetails.portName;
      dispatch({ type: "getVendorEquipmentDetailSuccess", data: "" });
    }
  }
  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch({ type: "ShowSidePan", data: false });
    dispatch({ type: "SubBannerTitle", data: "Vendor Management" });
    dispatch(getEquipmentNameList());
    dispatch(getApplicableSeviceTypewithIdList());
    dispatch(getServiceTypeList());
    dispatch(getZoneList());
    dispatch(getUnitList());
    dispatch(getPortAndCountry(this.state.searchData));
    let result = [];
    let arrayYears = [];
    let result1 = this.props.applicableServiceTypeList;
    let result2 = this.props.VendorEquipmentDetailList;
    let ID = parseInt(match.params.id);
    const newArr = removeObjectWithId(result2, ID);
    function removeObjectWithId(arr, id) {
      return arr?.filter((obj) => obj?.vendorId !== id);
    }
    if (newArr) {
      newArr.map((i) => {
        let serviceTypes= i.serviceTypeName;
        let item = i.serviceTypeId;
        arrayYears.push({
          item,
          serviceTypes,
        });
      });
    }
    result = result1?.filter(function (o1) {
      return arrayYears
        ? !arrayYears?.some(function (o2) {
            return o1.item === o2.item;
          })
        : [];
    });
    let newValue = [];
    newValue = arrayYears?.filter(
      (obj) => obj?.item === this.state.searchData.ServiceType
    );
    let newValue1=[...result, ...newValue];
    if (newValue.length !== 0) {
      var result3 = newValue1.reduce((unique, o) => {
        if(!unique.some(obj => obj.item === o.item)) {
          unique.push(o);
        }
        return unique;
    },[]);
    let list = [];
    let serviceTypeList = [];
    result3.map((item1, index) => {
      let listItem = item1.serviceTypes.split(" ");
      let order = listItem[0];
      let id = item1.item;
      list.push({
        id,
        order,
      });
    });
  
    let mainList = list.sort(function (a, b) {
      return a.order - b.order;
    });
    mainList.map((item, i) => {
      let serviceTypes = item.order + " yearly";
      item = item.id;
      serviceTypeList.push({
        item,
        serviceTypes,
      });
    });
  
      this.state.selectedServiceTypes =serviceTypeList;
      this.setState({});
    }else{
      this.state.selectedServiceTypes = result;
      this.setState({});
    }
   console.log("Final Result", arrayYears, result,this.state.selectedServiceTypes);
  }
  handleInputChange(e, node) {
    const{t}=this.props;
    if (node === "Price") {
      var pattern = /^[0-9]+([.][0-9]+)?$/;
      if ((!pattern.test($("#Price").val())) && ($("#Price").val()?.trim() !== "")) {
        $("#PriceErrMsg").text(`${t("ErrorMessage.InvalidMsg")}`);
        let invalid = this.state.inValidFields;
        this.setState({
          invalidFields: invalid.push("Price"),
        });
      } else {
        $("#PriceErrMsg").text("");
        let invalid = this.state.inValidFields;
        let length = this.state.inValidFields.length;
        var index = invalid.indexOf("Price");
        if (index != -1) {
          invalid.splice(index, length);
        }
        this.state.searchData[node] = e.target.value;
        this.setState({ invalidFields: invalid });
      }
    }
    if (node === "Quantity") {
      var pattern = /^(0|[1-9][0-9]*)$/;
      if (!pattern.test($("#Quantity").val())) {
        $("#QuantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`);
        let invalid = this.state.inValidFields;
        this.setState({
          invalidFields: invalid.push("Quantity"),
        });
      } else {
        $("#QuantityErrMsg").text("");
        let invalid = this.state.inValidFields;
        let length = this.state.inValidFields.length;
        var index = invalid.indexOf("Quantity");
        if (index != -1) {
          invalid.splice(index, length);
        }
        this.state.searchData[node] = e.target.value;
        this.setState({ invalidFields: invalid });
      }
    }
    this.state.searchData[node] = e.target.value;
    this.setState({});
  }
  vendorDetailsValidation() {
    const{t}=this.props;
    let equipment = this.state.searchData.EquipmentId;
    let zone = this.state.searchData.ZoneId;
    let serviceType = this.state.searchData.ServiceType;
    let unit = this.state.searchData.UnitId;
    let price = this.state.searchData.Price;
    let quantity = this.state.searchData.Quantity;
    let country = this.state.searchData.country;
    let port = this.state.searchData.port;
    let vendorName = this.state.searchData.vendorName;
    if (
      equipment !== "" &&
      zone !== "" &&
      serviceType !== "" &&
      unit !== "" &&
      price !== "" &&
      quantity !== "" &&
      country !== "" &&
      port !== "" &&
      vendorName !== ""
    ) {
      if (this.state.inValidFields.length === 0) {
        this.UpdateVendor();
      }
    } else {
      swal("Error!", `${t("CommonText.FillAllFieldMsg")}`, "warning");
    }
  }
  renderEquipmentTitle(state, val) {
    return (
      state?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
    );
  }

  UpdateVendor() {
    const { dispatch,t } = this.props;
    
    var decimals = this.state.searchData.Price- Math.floor(this.state.searchData.Price);
    console.log(decimals);
    if(decimals===0){
     this.state.searchData.Price=Math.round(this.state.searchData.Price);
     this.setState({})
    }
    let data = {
      vendorId: this.state.searchData.VendorId,
      vendorName: this.state.searchData.vendorName,
      equipmentName: this.state.searchData.EquipmentId,
      serviceTypeId: this.state.searchData.ServiceType.toString(),
      zoneId: parseInt(this.state.searchData.ZoneId),
      country: this.state.searchData.country,
      port: this.state.searchData.port,
      modifiedBy: currentuser.email,
      isDeleted: false,
      createdBy: "",
      price: this.state.searchData.Price,
      unitId: parseInt(this.state.searchData.UnitId),
      quantity: parseInt(this.state.searchData.Quantity),
    };
    searchData.VendorName=data.vendorName
    let url = `${API.postVendor}`;
    axios
      .post(url, data)
      .then((response) => {
        dispatch(getVendorList(searchData));
        this.hideSidePanel();
        toast.success(`${t("CommonText.CommonUpdate")}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch({
          type: "putVendorDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        swal("Error!", "Something went wrong. Please try again.", "warning");
        dispatch({
          type: "putVendorDetailFailure",
          error: "ERROR",
        });
      });
  }

  handleSelectChange(value, field) {
    if(field==="EquipmentId"){
      this.state.searchData.EquipmentId=value;
      this.setState({})
          }
    if (field === "country") {
      this.state.searchData[field] = value;
      this.setState({}, () => {
        console.log(this.state.searchData);
      });
      this.props.dispatch(getPortAndCountry(this.state.searchData));
    }
    this.state.searchData[field] = value;
    this.setState({}, () => {
      console.log(this.state.searchData);
    });
  }
  renderCountryTitle(state, val) {
    return state?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderPortTitle(state, val) {
    return state?.port?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }

  render() {
    const {
      EquipmentNameList,
      UnitList,
      zoneList,
      applicableServiceTypeList,
      PortList,
      Loading,
      VendorCountryList,
      t
    } = this.props;
    const { selectedServiceTypes } = this.state;
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3 ">
          <div className="col-lg-12">
            <div className="panel-box search-filter-box">
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1a3464",
                    color: "white",
                  }}
                >
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                     {t("VendorManagementScreenContent.EditVendor")}
                  </h5>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-lg-4">
                  <label className="form-label fontstyle required">
                  {t("VendorManagementScreenContent.VendorName")}
                  </label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    name="VendorName"
                    disabled
                    value={this.state.searchData.vendorName}
                    placeholder= {t("VendorManagementScreenContent.VendorName")}
                    onChange={(e) => this.handleInputChange(e, "vendorName")}
                  ></input>
                </div>
                <div className="col-lg-4">
                <div className="autocomplete-wrappers"
                            style={{
                              zIndex:this.state.openEquipment && !Loading
                                  ? 99999
                                  : null,
                            }}>
                            <label className="form-label fontstyle required"> {t("ShipEquipmentStatusScreen.Equipment")}</label>
                            <br></br>
                            <Autocomplete
                            open={!Loading ? this.state.openEquipment : false}
                            onMenuVisibilityChange={(isOpen) => {
                              this.state.openEquipment = isOpen;
                              this.setState({});
                            }}
                              contentEditable={true}
                              value={this.state.searchData.EquipmentId}
                              inputProps={{ placeholder:`${t("ShipEquipmentStatusScreen.Equipment")}` }}
                              items={EquipmentNameList ?? []}
                              getItemValue={(item) => item}
                              shouldItemRender={this.renderEquipmentTitle.bind(
                                this
                              )}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${
                                    isHighlighted ? "selected-items" : ""
                                  }`}
                                >
                                  {item}
                                </div>
                              )}
                              onChange={(e, field) =>
                                this.handleInputChange(e, "EquipmentId")
                              }
                              onSelect={(value,item) =>
                                this.handleSelectChange(value,"EquipmentId")
                              }
                            />
                          </div>
                </div>
                <div className="col-lg-4">
                  <label className="form-label fontstyle required">{t("ZoneScreen.Title")}</label>
                  <br></br>
                  <select
                    className="form-control"
                    id="Zone"
                    value={this.state.searchData.ZoneId}
                    onChange={(e) => this.handleInputChange(e, "ZoneId")}
                  >
                    <option value="">{t("VendorManagementScreenContent.SelectZone")}</option>
                    {zoneList &&
                      zoneList?.map((zonename) => (
                        <option value={zonename.id}>{zonename.value}</option>
                      ))}
                  </select>
                </div>
                <div className="col-lg-4 mt-2">
                  <div className="autocomplete-wrappers">
                    <label className="form-label fontstyle required">
                    {t("EquipmentServiceTypes.Country")}
                    </label>
                    <br></br>
                    <Autocomplete
                      contentEditable={true}
                      value={this.state.searchData.country}
                      inputProps={{ placeholder: `${t("EquipmentServiceTypes.Country")}`}}
                      items={VendorCountryList ?? []}
                      getItemValue={(item) => item}
                      shouldItemRender={this.renderCountryTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdown">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${
                            isHighlighted ? "selected-items" : ""
                          }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChange(e, "country")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(value, "country")
                      }
                    />
                    <span id="CountryErrMsg" className="spanErrMsg"></span>
                  </div>
                </div>
                <div className="col-lg-4 mt-2">
                  <div className="autocomplete-wrappers">
                    <label className="form-label fontstyle required">
                    {t("TopPaneContent.Port")}
                    </label>
                    <br></br>
                    <Autocomplete
                      contentEditable={true}
                      value={this.state.searchData.port}
                      inputProps={{ placeholder: `${t("TopPaneContent.Port")}` }}
                      items={PortList ?? []}
                      getItemValue={(item) => item.port}
                      shouldItemRender={this.renderPortTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdown">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${
                            isHighlighted ? "selected-items" : ""
                          }`}
                        >
                          {item.port}
                        </div>
                      )}
                      onChange={(e, field) => this.handleInputChange(e, "port")}
                      onSelect={(value) =>
                        this.handleSelectChange(value, "port")
                      }
                    />
                    <span id="PortErrMsg" className="spanErrMsg"></span>
                  </div>
                </div>
                <div className="col-lg-4 mt-2">
                  <label className="form-label fontstyle required">{t("TopPaneContent.Unit")}</label>
                  <br></br>
                  <select
                    className="form-control"
                    value={this.state.searchData.UnitId}
                    onChange={(e) => this.handleInputChange(e, "UnitId")}
                  >
                    <option value="">{t("VendorManagementScreenContent.SelectUnit")}</option>
                    {UnitList &&
                      UnitList?.map((unitname) => (
                        <option value={unitname.id}>{unitname.value}</option>
                      ))}
                  </select>
                </div>
                <div className="col-lg-4 mt-2">
                  <label className="form-label fontstyle required">
                  {t("ShipEquipmentStatusScreen.Quantity")}
                  </label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    id="Quantity"
                    name="Quantity"
                    value={this.state.searchData.Quantity}
                    placeholder= {t("ShipEquipmentStatusScreen.Quantity")}
                    onChange={(e) => this.handleInputChange(e, "Quantity")}
                  ></input>
                  <span id="QuantityErrMsg" className="spanErrMsg"></span>
                </div>
                <div className="col-lg-4 mt-2">
                  <label className="form-label fontstyle required">
                  {t("content.Servicetype")}
                  </label>
                  <select
                    className="form-control"
                    value={this.state.searchData.ServiceType}
                    onChange={(e) => this.handleInputChange(e, "ServiceType")}
                  >
                    <option value="">{t("EquipmentManagementScreenContent.SelectServiceType")}</option>
                    {selectedServiceTypes &&
                      selectedServiceTypes?.map((name) => (
                        <option value={name.item}>{name.serviceTypes}</option>
                      ))}
                  </select>
                </div>
                <div className="col-lg-4 mt-2">
                  <label className="form-label fontstyle required">{t("VendorManagementScreenContent.Price")}</label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    name="Price"
                    id="Price"
                    value={this.state.searchData.Price}
                    placeholder={t("VendorManagementScreenContent.Price")}
                    onChange={(e) => this.handleInputChange(e, "Price")}
                  ></input>
                  <span id="PriceErrMsg" className="spanErrMsg"></span>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.vendorDetailsValidation()}
                    >
                      {" "}
                      {t("EquipmentServiceTypes.Update")}{" "}
                    </button>

                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}
                    >
                      {" "}
                      {t("ComplianceandBudgetScreen.Cancel")}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  hideSidePanel() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.goBack();
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    applicableServiceTypeList:
      state.MasterScreenReducer.applicableServiceTypeList || [],
    VendorEquipmentDetailList:
      state.VendorManagementReducer.VendorEquipmentDetailList,
    VendorEquipmentDetails:
      state.VendorManagementReducer.VendorEquipmentDetails,
    serviceTypeList:
      state.MasterScreenReducer.applicableServiceTypeInterval || [],
    EquipmentNameList: state.MasterScreenReducer.EquipmentNameList || [],
    zoneList: state.VendorManagementReducer.zoneList,
    UnitList: state.VendorManagementReducer.UnitList,
    PortList: state.MasterScreenReducer.PortLists || [],
    VendorCountryList: state.VendorManagementReducer.VendorCountryList || [],
    Loading: state.PageLoaderReducer.loading,
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EditVendor)));
